import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { publicAssetPath } from '../lib/publicAsset';
import { getSafeRedirect, PENDING_LOGIN_REDIRECT_KEY } from '../lib/authRedirect';

export default function LoginPage() {
  const { user, authConfig } = useContext(AuthContext);
  const navigate = useNavigate();
  const redirectTarget = getSafeRedirect(new URLSearchParams(window.location.search).get('redirect'));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(() => new URLSearchParams(window.location.search).get('error') || '');

  useEffect(() => {
    if (user) navigate(redirectTarget, { replace: true });
  }, [user, navigate, redirectTarget]);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch('/api/auth/google/url', { credentials: 'same-origin' });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.msg || 'Google sign-in could not be started.');
      }
      window.localStorage.setItem(PENDING_LOGIN_REDIRECT_KEY, redirectTarget);
      window.location.assign(data.url);
    } catch (nextError) {
      setError(nextError.message || 'Google sign-in could not be started.');
      setLoading(false);
    }
  };

  return (
    <section className="container py-5" aria-labelledby="login-title">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-10 col-md-7 col-lg-5">
          <div className="login-card bg-card">
            <img
              src={publicAssetPath('web_logo.png')}
              alt="Hunar logo"
              className="login-brand-logo mb-3"
              style={{ maxHeight: '64px', width: 'auto', objectFit: 'contain' }}
            />
            <h1 id="login-title" className="brand-font">Sign in to Hunar</h1>
            <p className="login-copy">Use your verified Google account to continue.</p>

            {error && <div className="login-error" role="alert">{error}</div>}

            {authConfig.googleEnabled ? (
              <button
                type="button"
                className="btn btn-outline-custom login-google-button"
                onClick={handleGoogleSignIn}
                disabled={loading}
              >
                <span className="google-glyph" aria-hidden="true">G</span>
                {loading ? 'Opening Google…' : 'Continue with Google'}
              </button>
            ) : (
              <div className="login-unavailable" role="status">
                Google sign-in is not configured for Hunar yet.
              </div>
            )}

            <p className="login-footnote">Hunar login is Google-only. We never ask for or store your Google password.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
